import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p414319113508331520',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
